import {useMemo} from 'react';
import {useLocation, useParams} from 'react-router-dom';

import {Ref as PanelRef} from '../../../state/views/panel/types';
import {Ref as PanelBankSectionConfigRef} from '../../../state/views/panelBankSectionConfig/types';
import {useDetectPanelVariant} from '../hooks/hooks';
import {
  usePanelRefAndPanelBankSectionConfigRef,
  usePanelRefAndPanelBankSectionConfigRefByName,
} from './fullScreenUtils';

export const useFullScreenPanelLookup = () => {
  const location = useLocation();
  const {
    isFullScreenPanelById,
    isFullScreenPanelByName,
    isFullScreenPanelByNameAndSectionName,
    isFullScreenPanelPage,
  } = useDetectPanelVariant();
  const {panelId} = useParams<{panelId: string}>();
  const searchParams = new URLSearchParams(location.search);
  const panelDisplayName = searchParams.get('panelDisplayName');
  const panelSectionName = searchParams.get('panelSectionName');

  const panelRefAndPanelBankSectionConfigRefFromPanelId =
    usePanelRefAndPanelBankSectionConfigRef(panelId ?? '');

  const panelRefAndPanelBankSectionConfigRefFromDisplayName =
    usePanelRefAndPanelBankSectionConfigRefByName(
      panelDisplayName ?? '',
      panelSectionName ?? ''
    );

  let panelRefAndPanelBankSectionConfigRef: {
    panelRef: PanelRef;
    panelBankSectionConfigRef: PanelBankSectionConfigRef;
  } | null = null;

  if (isFullScreenPanelById) {
    panelRefAndPanelBankSectionConfigRef =
      panelRefAndPanelBankSectionConfigRefFromPanelId;
  }
  if (isFullScreenPanelByName || isFullScreenPanelByNameAndSectionName) {
    panelRefAndPanelBankSectionConfigRef =
      panelRefAndPanelBankSectionConfigRefFromDisplayName;
  }

  return useMemo(() => {
    return {
      isFullScreenPanelPage,
      panelRefAndPanelBankSectionConfigRef,
      isPanelNotFound: !panelRefAndPanelBankSectionConfigRef,
    };
  }, [isFullScreenPanelPage, panelRefAndPanelBankSectionConfigRef]);
};
